import qs from 'qs'
import React, { useContext, useEffect } from 'react'
import config from '../../config.json'
import {
    getImage,
    setQueryStringWithoutPageReload,
} from '../helpers/FormatLinks'
import Page from '../page/Page'
import SearchComponent from '../searchitems/'
import { Context } from '../waxplorer/Waxplorer'

const BuyOffers = (props) => {
    let values =
        typeof window !== 'undefined'
            ? qs.parse(
                  window.location.search.substring(
                      1,
                      window.location.search.length,
                  ),
              )
            : []

    const [state] = useContext(Context)

    const searchAuthor =
        typeof window !== 'undefined'
            ? state.searchAuthor
                ? state.searchAuthor
                : values['collection']
            : props.collection

    const collectionDetails = props['collection_details']
    const collectionName = collectionDetails ? collectionDetails['name'] : null

    const limitIncrease = 60

    const getAssets = async () => {
        const query = values

        query['search_type'] = 'buyoffers'
        query['order_by'] = 'date_desc'

        setQueryStringWithoutPageReload(qs.stringify(query))
    }

    useEffect(() => {
        if (typeof window !== 'undefined') getAssets()
    }, [limitIncrease])

    const image = getImage(searchAuthor)

    return (
        <Page
            id={'BuyOfferPage'}
            title={config.titles.market.replace(
                '{collectionName}',
                collectionName ? 'for ' + collectionName : '',
            )}
            description={config.descriptions.market.replace(
                '{collectionName}',
                collectionName ? collectionName + ', ' : '',
            )}
            image={image}
            {...props}
            pageTitle={'Buy Offers'}
            pageSubtitle={
                'Discover Irresistible Deals: Dive into Our Buy Offers Today!'
            }
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Buy Offers',
                    link: '/buyoffers',
                },
            ]}
        >
            <SearchComponent
                {...props}
                searchSettings={{
                    owner: '',
                    search_type: {
                        value: 'buyoffers',
                        fixed: false,
                    },
                    order_by: { value: 'date_desc', fixed: false },
                    minimal: false,
                    tab: 'buyoffers',
                    page_component: false,
                    limit: { value: limitIncrease, fixed: true },
                    expanded: false,
                }}
                limit={60}
                tab={'buyoffers'}
            />
        </Page>
    )
}

export default BuyOffers
